import React from "react";
import { FiFileText, FiTruck, FiBox, FiTrash2 } from "react-icons/fi";
import "./ModalSelectorTipo.css";

function ModalSelectorTipo({ isOpen, onClose, onSelectTipo, opciones }) {
  if (!isOpen) return null;

  const permitidas = opciones || ["di", "carta_maquina", "carta_arido"];

  const handleSelectTipo = (tipo) => {
    onSelectTipo(tipo);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content selector-tipo" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>¿Qué deseas crear?</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body options-grid">
          {permitidas.includes("di") && (
          <div
            className="option-card"
            onClick={() => handleSelectTipo("di")}
          >
            <FiFileText className="option-icon" />
            <div className="option-title">DI (Albarán)</div>
            <div className="option-description">
              Documento de Identificación de Traslado de Residuos
            </div>
          </div>
          )}

          {permitidas.includes("di_contenedor") && (
          <div
            className="option-card"
            onClick={() => handleSelectTipo("di_contenedor")}
          >
            <FiTrash2 className="option-icon" />
            <div className="option-title">DI Contenedor</div>
            <div className="option-description">
              Llevada, cambio o retirada de contenedores
            </div>
          </div>
          )}

          {permitidas.includes("carta_maquina") && (
          <div
            className="option-card"
            onClick={() => handleSelectTipo("carta_maquina")}
          >
            <FiTruck className="option-icon" />
            <div className="option-title">Carta de Porte - Carga</div>
            <div className="option-description">
              Transporte de maquinaria
            </div>
          </div>
          )}

          {permitidas.includes("carta_arido") && (
          <div
            className="option-card"
            onClick={() => handleSelectTipo("carta_arido")}
          >
            <FiBox className="option-icon" />
            <div className="option-title">Carta de Porte - Árido</div>
            <div className="option-description">
              Transporte de árido y material granular
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalSelectorTipo;
